var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-wrapper"},[(_vm.developerInfo.dev_state !== 1)?_c('el-menu',{staticClass:"el-menu-vertical",attrs:{"default-active":_vm.defaultActivePath}},_vm._l((_vm.menuList),function(route){return _c('SidebarItem',{key:route.name,attrs:{"item":route,"base-path":route.path}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }